module.exports = __webpack_public_path__ + "img/email-submitted.a3aa0d09.svg";